import { c as _c } from "react/compiler-runtime";
import { type LinkProps } from './types';
import { StyledLink } from './styles';
import { forwardRef } from 'react';
const Link = forwardRef<HTMLAnchorElement, LinkProps>((t0, ref) => {
  const $ = _c(15);
  let children;
  let href;
  let props;
  let t1;
  let t2;
  let t3;
  if ($[0] !== t0) {
    ({
      variant: t1,
      color: t2,
      href,
      target: t3,
      children,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = href;
    $[3] = props;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    children = $[1];
    href = $[2];
    props = $[3];
    t1 = $[4];
    t2 = $[5];
    t3 = $[6];
  }
  const variant = t1 === undefined ? "body1" : t1;
  const color = t2 === undefined ? "default" : t2;
  const target = t3 === undefined ? "_self" : t3;
  let t4;
  if ($[7] !== children || $[8] !== color || $[9] !== href || $[10] !== props || $[11] !== ref || $[12] !== target || $[13] !== variant) {
    t4 = <StyledLink variant={variant} linkColor={color} href={href} target={target} {...props} ref={ref}>{children}</StyledLink>;
    $[7] = children;
    $[8] = color;
    $[9] = href;
    $[10] = props;
    $[11] = ref;
    $[12] = target;
    $[13] = variant;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  return t4;
});
export default Link;
export { Link };
export type { LinkColor, LinkProps, LinkTargetTypes } from './types';
export { LINK_COLORS } from './types';